// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3ENS3","cell":"ColumnAccessor_cell__34VKL","firstCellAccent":"ColumnAccessor_firstCellAccent__2NaMH"};